import subdomainLogos from '../../public/assets/logos/subdomainLogos.json';
import { getSubdomain } from './subdomain';

// Default URLs
const defaultUrls = {
  navbar: '/assets/logos/fp/logo_navbar.png',
  footer: '/assets/logos/fp/logo_footer.png',
  favicon: '/assets/logos/fp/favicon.ico'
};

export function getLogoURLs() {
  const subdomain = getSubdomain();
  return subdomainLogos[subdomain] || defaultUrls;
}
